import React from 'react';
import { useTranslation } from 'react-i18next';

import './Gallery.scss';

import SectionTitle from '../../components/SectionTitle/SectionTitle';

import imgOne from '../../assets/servicePage/gallery/1.webp';
import imgTwo from '../../assets/servicePage/gallery/2.webp';
import imgThree from '../../assets/servicePage/gallery/3.webp';
import imgFour from '../../assets/servicePage/gallery/4.webp';
import imgFive from '../../assets/servicePage/gallery/5.webp';
import imgSix from '../../assets/servicePage/gallery/6.webp';

const Gallery = () => {
    const { t } = useTranslation();

    return (
        <section
            className="gallery-section"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">

                <SectionTitle
                    subTitle={t('gallery.subTitle')}
                    title={t('gallery.title')}
                    description={t('gallery.description')}
                />

                <div className="row">

                    <div className="col-md-5 col-sm-6">
                        <div className="gallery-img">
                            <img
                                src={imgOne}
                                alt={t('gallery.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 col-sm-6">
                        <div className="gallery-img">
                            <img
                                src={imgTwo}
                                alt={t('gallery.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-6">
                        <div className="gallery-img">
                            <img
                                src={imgThree}
                                alt={t('gallery.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 col-sm-6">
                        <div className="gallery-img">
                            <img
                                src={imgFour}
                                alt={t('gallery.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 col-sm-6">
                        <div className="gallery-img">
                            <img
                                src={imgFive}
                                alt={t('gallery.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-md-5 col-sm-6">
                        <div className="gallery-img">
                            <img
                                src={imgSix}
                                alt={t('gallery.imageAlt')}
                            />
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default Gallery;